export default {
    //判断对象中是否有属性
    isValidKey(key: string | number | symbol, object: object): key is keyof typeof object {
        return key in object;
    },
    //判断当前环境是否为微信小程序
    isMiniProgram() {
        // let judgeMiniProgram = false;
        // // 先验证是否在微信类浏览器中
        // if (/MicroMessenger/i.test(navigator.userAgent)) {
        //     window['wx'].miniProgram.getEnv((res: any) => {
        //         if (res.miniprogram) {
        //             console.log('在小程序里');
        //             judgeMiniProgram = true;
        //         } else {
        //             console.log('不在小程序里');
        //             judgeMiniProgram = false;
        //         }
        //     });
        // } else {
        //     console.log('不在微信里');
        //     judgeMiniProgram = false;
        // }
        // return judgeMiniProgram;
        const isInMiniProgram = /miniProgram/i.test(navigator.userAgent);
        return isInMiniProgram;
    },
    //获取当前环境的baseURL
    getLocationUrl() {
        let env = process.env.REACT_APP_ENV;
        let baseUrl = '';
        //开发环境
        if (env === 'development') {
            baseUrl = 'http://106.14.197.93:9090/'
        }
        //测试环境
        else if (env === 'test') {
            baseUrl = 'https://edc-saas-test.huimeimt.com/wechat/'
        }
        //生产环境（未定）
        else if (env === 'production') {
            baseUrl = 'https://edc-saas-test.huimeimt.com/wechat/'
        }
        return baseUrl;
    },
    // 获取url参数
    getUrlParams(urlStr: string | void): any {
        // console.log(urlStr);
        let url = urlStr;
        if (typeof url == 'undefined') {
            url = decodeURI(window.location.href); //获取url中'?'符后的字符串
        }
        const theRequest = new Object();
        if (url.indexOf('?') != -1) {
            let arr = url.split('?');
            let str = arr[arr.length - 1]; // 因为#号，可能有多个?
            let strs = str.split('&');
            for (let i = 0; i < strs.length; i++) {
                if (theRequest[strs[i].split('=')[0]]) {
                    // 有重复的key时
                    if (Array.isArray(theRequest[strs[i].split('=')[0]])) {
                        theRequest[strs[i].split('=')[0]] = [...theRequest[strs[i].split('=')[0]], decodeURI(strs[i].split('=')[1])];
                    } else {
                        // 有重复的key时
                        theRequest[strs[i].split('=')[0]] = [theRequest[strs[i].split('=')[0]], decodeURI(strs[i].split('=')[1])];
                    }
                } else {
                    // 没有重复的key时
                    theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
                }
            }
        }
        return theRequest;
    },
    // 文件下载
    downloadFile(url: any) {
        var x = new XMLHttpRequest();
        x.open("GET", url, true);
        x.responseType = 'blob';
        x.onload = function (e) {
            var url = window.URL.createObjectURL(x.response)
            var a = document.createElement('a');
            a.href = url
            a.download = '下载';
            a.click()
        }
        x.send();
    },
    // base64图片转成文件
    base64ToFile(dataUrl: any, name: any) {
        var arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], name + '.jpg', { type: "image/jpg" });
    }
}